module.exports = __webpack_public_path__ + "static/media/checkpoint2.b807810b.png";